import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import { LocalDate } from '../utils/local-date';
import SiteInvoice from './site-invoice';
import type SiteMenuBeverageOrder from './site-menu-beverage-order';
import type SiteMenuOrder from './site-menu-order';
import type SiteMenuSupplyOrder from './site-menu-supply-order';

@JsonApiResource({
  type: 'site-invoices-item',
})
export default class SiteInvoicesItem extends BaseEntity {
  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) })
  public orderDate: LocalDate;

  @JsonApiRelationship('site-invoice') public siteInvoice: SiteInvoice;
  @JsonApiRelationship('site-menu-order') public siteMenuOrder: SiteMenuOrder | null;
  @JsonApiRelationship('site-menu-beverage-order')
  public siteMenuBeverageOrder: SiteMenuBeverageOrder | null;

  @JsonApiRelationship('site-menu-supply-order')
  public siteMenuSupplyOrder: SiteMenuSupplyOrder | null;

  @JsonApiProperty({ resolver: Number })
  public price: number = 0.0;

  constructor(
    id?: BaseEntity['id'],
    public name: string = '',
    public displayName: string = '',
    public quantity: number = 1,
    price: number = 0.0,
    public serviceType: string = '',
    orderDate: SiteInvoicesItem['orderDate'] = new LocalDate(),
    siteInvoice: SiteInvoice = new SiteInvoice(),
    siteMenuOrder?: SiteInvoicesItem['siteMenuOrder'],
    siteMenuBeverageOrder?: SiteInvoicesItem['siteMenuBeverageOrder'],
    siteMenuSupplyOrder?: SiteInvoicesItem['siteMenuSupplyOrder']
  ) {
    super();
    this.id = id;
    this.orderDate = orderDate;
    this.siteInvoice = siteInvoice;
    this.siteMenuOrder = siteMenuOrder ?? null;
    this.siteMenuBeverageOrder = siteMenuBeverageOrder ?? null;
    this.siteMenuSupplyOrder = siteMenuSupplyOrder ?? null;
    this.price = price;
  }
}
